module.exports = __webpack_public_path__ + "static/media/IMG_1192.24faa6b3.jpg";